import { useEffect, useState } from 'react'
import Paginate from '../pagination/paginate'
import { useNavigate, useParams } from 'react-router-dom'
import { appGetHubById } from '../../store/hubs'
import { appGetAllUser, appUploadUser, appUpdateUser } from '../../store/user'
import { useDispatch, useSelector } from 'react-redux'
import * as XLSX from 'xlsx'
import swal from 'sweetalert'
import PostPreview from '../PostPreview/PostPreview'
import { sansthaUserExportColumns } from '../../config/exportColumns/sansthaUserExportColumns'
import ExportButton from '../../common/ExportButton'

function Users({ hubDetails, sansthaDetails, users, userpage, setUserPage }) {
	const params = useParams()
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const [isUploading, setIsUploading] = useState(false)
	const [openMenuId, setOpenMenuId] = useState(null)

	const [searchType, setSearchType] = useState('firstName')
	const [search, setSearch] = useState('')
	const [activeFilters, setActiveFilters] = useState({})

	const userspaginate = useSelector(state => state.usersReducer.paginate)
	const userLabel = sansthaDetails && sansthaDetails._id ? 'Member' : 'User'

	useEffect(() => {
		const params = {
			page: userpage,
			limit: 10,
			...activeFilters,
		}

		if (sansthaDetails?._id) {
			params.sansthaId = sansthaDetails._id
		} else if (hubDetails?._id) {
			params.hub = hubDetails._id
		}

		dispatch(appGetAllUser(params))
	}, [userpage, activeFilters, sansthaDetails?._id, hubDetails?._id])

	useEffect(() => {
		const closeMenu = () => setOpenMenuId(null)
		document.addEventListener('click', closeMenu)
		return () => document.removeEventListener('click', closeMenu)
	}, [])

	// const handleDownloadExcel = () => {
	//   const sampleData = [
	//     {
	//       firstName: "",
	//       lastName: "",
	//       email: "",
	//       mobile: "",
	//     },
	//   ];

	//   const wb = XLSX.utils.book_new();
	//   const ws = XLSX.utils.json_to_sheet(sampleData);

	//   XLSX.utils.book_append_sheet(wb, ws, "Users");

	//   XLSX.writeFile(wb, "users_template.xlsx");
	// };
	//     const handleDownloadExcel = () => {
	//   let sampleData = [];

	//   if (sansthaDetails && sansthaDetails._id) {
	//     sampleData = [
	//       {
	//         firstName: "",
	//         lastName: "",
	//         email: "",
	//         mobile: "",
	//         membershipStartDate: "",
	//         membershipEndDate: "",
	//         membershipType: "",
	//       },
	//     ];
	//   } else if (hubDetails && hubDetails._id) {
	//     sampleData = [
	//       {
	//         firstName: "",
	//         lastName: "",
	//         email: "",
	//         mobile: "",
	//       },
	//     ];
	//   }

	//   const wb = XLSX.utils.book_new();
	//   const ws = XLSX.utils.json_to_sheet(sampleData);

	//   XLSX.utils.book_append_sheet(wb, ws, "Users");

	//   XLSX.writeFile(wb, "users_template.xlsx");
	// };

	//   const handleExcelImport = (event) => {
	//     const file = event.target.files[0];
	//     const reader = new FileReader();
	//     reader.onload = (e) => {
	//       try {
	//         const workbook = XLSX.read(e.target.result, { type: "binary" });
	//         const sheetName = workbook.SheetNames[0];
	//         const worksheet = workbook.Sheets[sheetName];
	//         const data = XLSX.utils.sheet_to_json(worksheet);

	//         const requiredFields = ["firstName", "lastName", "mobile"];
	//         const isValidData = data.every((row) =>
	//           requiredFields.every((field) => row[field] !== undefined)
	//         );

	//         if (!isValidData) {
	//           console.log(
	//             "Invalid Data Structure. Required fields:",
	//             requiredFields
	//           );
	//           swal(
	//             "Error",
	//             "Excel file must contain firstName,lastName, email, and mobile columns",
	//             "error"
	//           );
	//           return;
	//         }

	//         if (hubDetails && hubDetails._id) {
	//           dispatch(
	//             appUploadUser({
	//               hub: hubDetails._id,
	//               file,
	//             })
	//           )
	//             .then(() => {
	//               dispatch(
	//                 appGetAllUser({ page: 1, limit: 10, hub: hubDetails._id })
	//               );
	//               dispatch(appGetHubById(hubDetails._id));
	//             })
	//             .catch((error) => {
	//               swal("Error", "Failed to upload users data", "error");
	//             });
	//         } else if (sansthaDetails && sansthaDetails._id) {
	//           dispatch(
	//             appUploadUser({
	//               hub: sansthaDetails?.hub._id,
	//               sansthaId: sansthaDetails._id,
	//               file,
	//             })
	//           )
	//             .then(() => {
	//               dispatch(
	//                 appGetAllUser({
	//                   page: 1,
	//                   limit: 10,
	//                   sansthaId: sansthaDetails._id,
	//                 })
	//               );
	//             })
	//             .catch((error) => {
	//               console.error("Upload failed:", error);
	//               swal("Error", "Failed to upload users data", "error");
	//             });
	//         }
	//       } catch (error) {
	//         console.error("Error processing Excel file:", error);
	//         swal("Error", "Failed to process Excel file", "error");
	//       }
	//     };

	//     reader.onerror = () => {
	//       console.error("Error reading file");
	//       swal("Error", "Failed to read Excel file", "error");
	//     };

	//     if (file) {
	//       console.log("Selected file:", file.name);
	//       reader.readAsBinaryString(file);
	//     }
	//   };

	// const handleDownloadExcel = () => {
	// 	let sampleData = []

	// 	if (sansthaDetails && sansthaDetails._id) {
	// 		sampleData = [
	// 			{
	// 				firstName: 'John',
	// 				lastName: 'Doe',
	// 				email: 'john.doe@example.com',
	// 				mobile: '9876543210',
	// 				membershipStartDate: '01-01-2025',
	// 				membershipEndDate: '31-12-2025',
	// 				membershipType: 'Yearly',
	// 			},
	// 			{
	// 				firstName: 'Jane',
	// 				lastName: 'Smith',
	// 				email: 'jane.smith@example.com',
	// 				mobile: '9876500000',
	// 				membershipStartDate: '01-02-2025',
	// 				membershipEndDate: '28-02-2025',
	// 				membershipType: 'Monthly',
	// 			},
	// 			{
	// 				firstName: 'Alex',
	// 				lastName: 'Brown',
	// 				email: 'Alex.Brown@example.com',
	// 				mobile: '9999988888',
	// 				membershipStartDate: '01-01-2020',
	// 				membershipEndDate: '21-11-2025',
	// 				membershipType: 'Lifetime',
	// 			},
	// 		]
	// 	} else if (hubDetails && hubDetails._id) {
	// 		sampleData = [
	// 			{
	// 				firstName: '',
	// 				lastName: '',
	// 				email: '',
	// 				mobile: '',
	// 			},
	// 		]
	// 	}

	// 	if (!sampleData.length) {
	// 		sampleData = [
	// 			{
	// 				firstName: '',
	// 				lastName: '',
	// 				email: '',
	// 				mobile: '',
	// 			},
	// 		]
	// 	}

	// 	// Create workbook
	// 	const wb = XLSX.utils.book_new()

	// 	// Create "Instructions" sheet (note for users)
	// 	const note = [
	// 		[
	// 			`👉 Sample reference data — Please replace with actual ${
	// 				sansthaDetails ? 'member' : 'user'
	// 			} details before uploading.`,
	// 		],
	// 		['Keep this sheet for instructions only. The data sheet is separate.'],
	// 	]
	// 	const wsNote = XLSX.utils.aoa_to_sheet(note)
	// 	XLSX.utils.book_append_sheet(wb, wsNote, 'Instructions')

	// 	// Create data sheet with headers in row 1
	// 	const wsData = XLSX.utils.json_to_sheet(sampleData, { origin: 'A1' })

	// 	// Set reasonable column widths
	// 	const columnWidths = Object.keys(sampleData[0]).map(() => ({ wch: 20 }))
	// 	wsData['!cols'] = columnWidths

	// 	XLSX.utils.book_append_sheet(wb, wsData, sansthaDetails ? 'Members' : 'Users')

	// 	// File name
	// 	const filename = sansthaDetails ? 'sanstha_members_template.xlsx' : 'hub_users_template.xlsx'

	// 	XLSX.writeFile(wb, filename)
	// }

	// const handleExcelImport = event => {
	// 	const file = event.target.files[0]
	// 	if (!file) return

	// 	const reader = new FileReader()

	// 	reader.onload = e => {
	// 		try {
	// 			// Use array buffer for better compatibility
	// 			const data = e.target.result
	// 			const workbook = XLSX.read(data, { type: 'array' })

	// 			// required fields to validate
	// 			const requiredFields = ['firstName', 'lastName', 'mobile']

	// 			// Try to find a sheet that contains the required headers
	// 			let parsedData = null
	// 			for (const sheetName of workbook.SheetNames) {
	// 				const worksheet = workbook.Sheets[sheetName]

	// 				// Get rows as arrays so we can detect header row anywhere
	// 				const rows = XLSX.utils.sheet_to_json(worksheet, {
	// 					header: 1,
	// 					defval: '',
	// 				})

	// 				// Find header row index which contains all required fields (case-insensitive)
	// 				let headerIndex = -1
	// 				for (let i = 0; i < Math.min(rows.length, 5); i++) {
	// 					const row = rows[i].map(c => (typeof c === 'string' ? c.trim().toLowerCase() : c))
	// 					const hasAll = requiredFields.every(f => row.includes(f.toLowerCase()))
	// 					if (hasAll) {
	// 						headerIndex = i
	// 						break
	// 					}
	// 				}

	// 				if (headerIndex === -1) {
	// 					// not this sheet
	// 					continue
	// 				}

	// 				// Build header array from headerIndex row
	// 				const headers = rows[headerIndex].map(h => (typeof h === 'string' ? h.trim() : h))

	// 				// Build data rows from the rows after headerIndex
	// 				const dataRows = rows.slice(headerIndex + 1)

	// 				parsedData = dataRows
	// 					.map(r => {
	// 						const obj = {}
	// 						headers.forEach((h, idx) => {
	// 							if (h) obj[h] = r[idx] !== undefined ? r[idx] : ''
	// 						})
	// 						return obj
	// 					})
	// 					.filter(row => {
	// 						// Remove completely empty rows
	// 						return Object.values(row).some(v => v !== '' && v !== null)
	// 					})

	// 				// stop searching sheets if parsedData found
	// 				if (parsedData && parsedData.length >= 0) break
	// 			}

	// 			if (!parsedData) {
	// 				console.error('No valid sheet with required headers found.')
	// 				swal('Error', 'Excel file must contain columns: firstName, lastName, and mobile', 'error')
	// 				return
	// 			}

	// 			//	console.log('Parsed Data:', parsedData)

	// 			// Validate that every parsed row contains required fields (non-empty)
	// 			const isValidData = parsedData.every(row =>
	// 				requiredFields.every(field => {
	// 					// field names might be case-insensitive in headers, so we try both direct and lower-case lookups
	// 					if (row[field] !== undefined && row[field] !== '') return true
	// 					// try case-insensitive keys
	// 					const key = Object.keys(row).find(
	// 						k => typeof k === 'string' && k.toLowerCase() === field.toLowerCase(),
	// 					)
	// 					return key ? row[key] !== '' : false
	// 				}),
	// 			)

	// 			if (!isValidData) {
	// 				//console.log('Invalid Data Structure. Required fields:', requiredFields)
	// 				swal(
	// 					'Error',
	// 					'Excel file must contain firstName, lastName, and mobile columns (and those cells must not be empty).',
	// 					'error',
	// 				)
	// 				return
	// 			}

	// 			// If validation passed, dispatch upload (unchanged from your original logic)
	// 			if (hubDetails && hubDetails._id) {
	// 				dispatch(
	// 					appUploadUser({
	// 						hub: hubDetails._id,
	// 						file,
	// 					}),
	// 				)
	// 					.then(() => {
	// 						dispatch(appGetAllUser({ page: 1, limit: 10, hub: hubDetails._id }))
	// 						dispatch(appGetHubById(hubDetails._id))
	// 					})
	// 					.catch(error => {
	// 						console.error('Upload failed:', error)
	// 						swal('Error', 'Failed to upload users data', 'error')
	// 					})
	// 			} else if (sansthaDetails && sansthaDetails._id) {
	// 				dispatch(
	// 					appUploadUser({
	// 						hub: sansthaDetails?.hub._id,
	// 						sansthaId: sansthaDetails._id,
	// 						file,
	// 					}),
	// 				)
	// 					.then(() => {
	// 						dispatch(
	// 							appGetAllUser({
	// 								page: 1,
	// 								limit: 10,
	// 								sansthaId: sansthaDetails._id,
	// 							}),
	// 						)
	// 					})
	// 					.catch(error => {
	// 						console.error('Upload failed:', error)
	// 						swal('Error', 'Failed to upload users data', 'error')
	// 					})
	// 			}
	// 		} catch (error) {
	// 			console.error('Error processing Excel file:', error)
	// 			swal('Error', 'Failed to process Excel file', 'error')
	// 		}
	// 	}

	// 	reader.onerror = () => {
	// 		console.error('Error reading file')
	// 		swal('Error', 'Failed to read Excel file', 'error')
	// 	}

	// 	// Read as array buffer for XLSX.read(..., { type: 'array' })
	// 	reader.readAsArrayBuffer(file)
	// }

	const handleDownloadExcel = () => {
		const sampleData = [
			{
				firstName: 'John',
				lastName: 'Doe',
				mobile: '9876543210',
			},
			{
				firstName: 'Jane',
				lastName: 'Smith',
				mobile: '9876500000',
			},
		]

		const wb = XLSX.utils.book_new()

		const wsData = XLSX.utils.json_to_sheet(sampleData, { origin: 'A1' })

		wsData['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 15 }]

		XLSX.utils.book_append_sheet(wb, wsData, sansthaDetails ? 'Members' : 'Users')

		const filename = sansthaDetails ? 'sanstha_members_template.xlsx' : 'hub_users_template.xlsx'

		XLSX.writeFile(wb, filename)
	}

	const handleExcelImport = event => {
		const file = event.target.files[0]
		if (!file) return

		setIsUploading(true)

		if (hubDetails && hubDetails._id) {
			dispatch(
				appUploadUser({
					hub: hubDetails._id,
					file,
				}),
			)
				.then(() => {
					swal('Success', 'Users uploaded successfully!', 'success')
					dispatch(appGetAllUser({ page: 1, limit: 10, hub: hubDetails._id }))
					dispatch(appGetHubById(hubDetails._id))
				})
				.catch(error => {
					swal('Upload Failed', error?.response?.data?.message || 'Failed to upload users', 'error')
				})
				.finally(() => {
					setIsUploading(false)
				})
		} else if (sansthaDetails && sansthaDetails._id) {
			dispatch(
				appUploadUser({
					hub: sansthaDetails.hub._id,
					sansthaId: sansthaDetails._id,
					file,
				}),
			)
				.then(() => {
					swal('Success', 'Members uploaded successfully!', 'success')
					dispatch(
						appGetAllUser({
							page: 1,
							limit: 10,
							sansthaId: sansthaDetails._id,
						}),
					)
				})
				.catch(error => {
					swal(
						'Upload Failed',
						error?.response?.data?.message || 'Failed to upload members',
						'error',
					)
				})
				.finally(() => {
					setIsUploading(false)
				})
		}

		event.target.value = ''
	}

	const getStatusBadgeClass = status => {
		switch (status) {
			case 'Active':
				return 'badge-success'
			case 'Inactive':
				return 'badge-danger'
			case 'Expired':
				return 'badge-warning'
			default:
				return 'badge-secondary'
		}
	}

	// const handleBlockUser = (userId, isCurrentlyBlocked) => {
	// 	swal({
	// 		title: isCurrentlyBlocked ? 'Unblock User?' : 'Block User?',
	// 		text: isCurrentlyBlocked
	// 			? 'Are you sure you want to unblock this user?'
	// 			: 'Please provide a reason for blocking this user',
	// 		icon: 'warning',
	// 		content: !isCurrentlyBlocked
	// 			? {
	// 					element: 'input',
	// 					attributes: {
	// 						placeholder: 'Enter reason (required)',
	// 						type: 'text',
	// 					},
	// 			  }
	// 			: null,
	// 		buttons: {
	// 			cancel: true,
	// 			confirm: {
	// 				text: 'Confirm',
	// 				closeModal: false,
	// 			},
	// 		},
	// 		dangerMode: !isCurrentlyBlocked,
	// 	}).then(reason => {
	// 		if (reason === null) return

	// 		if (!isCurrentlyBlocked && (!reason || !reason.trim())) {
	// 			swal({
	// 				title: 'Error',
	// 				text: 'Reason is required to block a user',
	// 				icon: 'error',
	// 			})
	// 			return
	// 		}

	// 		dispatch(
	// 			appUpdateUser({
	// 				id: userId,
	// 				isUserBlocked: !isCurrentlyBlocked,
	// 				// blockReason: reason?.trim() || null,
	// 				navigate,
	// 			}),
	// 		).then(() => {
	// 			swal(
	// 				'Success',
	// 				`User ${isCurrentlyBlocked ? 'unblocked' : 'blocked'} successfully`,
	// 				'success',
	// 			)
	// 			dispatch(appGetAllUser({ page: 1, limit: 10 }))
	// 		})
	// 	})
	// }

	const handleSearch = () => {
		const filters = {}

		if (search) {
			filters[searchType] = search.trim()
		}

		setActiveFilters(filters)
		setUserPage(1)
	}
	const handleReset = () => {
		setSearch('')
		setSearchType('firstName')
		setActiveFilters({})
		setUserPage(1)
	}

	return (
		<div>
			<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
				<h4 className="ml-2 text-black">
					Total {userLabel}s: {hubDetails?.users?.length || sansthaDetails?.users?.length || 0}
				</h4>

				<div className="d-flex align-items-center mb-3 gap-2">
					<select
						className="form-control"
						value={searchType}
						onChange={e => setSearchType(e.target.value)}
						style={{ width: '180px' }}
					>
						<option value="firstName">First Name</option>
						<option value="lastName">Last Name</option>
						<option value="mobile">Mobile</option>
						<option value="email">Email</option>
					</select>

					<input
						type="text"
						className="form-control ml-1"
						placeholder={`Search by ${searchType}`}
						value={search}
						onChange={e => setSearch(e.target.value)}
						style={{ width: '220px' }}
					/>

					<button className="btn btn-info mx-2" onClick={handleSearch}>
						Search
					</button>

					<button className="btn btn-secondary" onClick={handleReset}>
						Reset
					</button>
				</div>

				<div className="dt-buttons btn-group">
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllUser({
									...params,
									page: 1,
									limit: 100000,
									...(hubDetails?._id && { hub: hubDetails._id }),
									...(sansthaDetails?._id && { sansthaId: sansthaDetails._id }),
									loading: false,
								}),
							)
						}
						columns={sansthaUserExportColumns}
						fileName={sansthaDetails ? 'Sanstha_Members' : 'Hub_Users'}
						sheetName={sansthaDetails ? 'Members' : 'Users'}
						buttonText="Export Users"
						className="btn btn-info mr-2"
					/>

					<button
						className="btn btn-default buttons-excel buttons-html5 btn-info mr-2 ml-2"
						onClick={handleDownloadExcel}
						style={{ minWidth: '150px', height: '38px' }}
					>
						<span>Download {userLabel} Template</span>
					</button>

					<label
						className={`btn btn-info d-flex align-items-center gap-2 ${
							isUploading ? 'disabled' : ''
						}`}
						style={{
							minWidth: '170px',
							height: '38px',
							cursor: isUploading ? 'not-allowed' : 'pointer',
						}}
					>
						{isUploading && (
							<span
								className="spinner-border spinner-border-sm"
								role="status"
								aria-hidden="true"
							></span>
						)}
						{isUploading ? `Uploading ${userLabel}...` : `Upload ${userLabel}`}

						<input
							type="file"
							accept=".xlsx, .xls"
							style={{ display: 'none' }}
							onChange={handleExcelImport}
							disabled={isUploading}
						/>
					</label>
				</div>
			</div>
			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>{userLabel}</th>
							<th>Mobile</th>
							<th>Native Address</th>
							<th>Present Address</th>
							{sansthaDetails?._id && (
								<>
									<th>Membership Start Date</th>
									<th>Membership End Date</th>
									<th>Membership Type</th>
								</>
							)}
							<th>Joined Date</th>
							<th>Premium Member</th>
							{sansthaDetails?._id && <th>Membership Status</th>}

							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{users?.length > 0 ? (
							users.map((user, index) => {
								const matchedMembership = user?.joinedSanstha?.find(
									item => item?.sanstha?._id === sansthaDetails?._id,
								)
								return (
									<tr
										key={index}
										onClick={e => {
											if (
												e.target.closest('td:last-child') ||
												e.target.closest('button') ||
												e.target.closest('.btn')
											) {
												return
											}
											navigate(`/user/details/${user?._id}`)
										}}
										style={{
											cursor: 'pointer',
											backgroundColor: user?.isUserBlocked ? '#ffe5e5' : '',
										}}
									>
										<td>{index + 1 + (userpage - 1) * 10}</td>
										<td>
											<PostPreview value={user.profilePic || '/img/user.jpg'} />
											{user.firstName} {user.lastName}
										</td>
										<td>{user.mobile}</td>
										<td>
											{user?.nativePlaceAddress && user?.nativeArea && (
												<>
													{user?.nativePlaceAddress}, {user?.nativeArea}
												</>
											)}

											<br />
											{user?.nativeBlock &&
												user?.nativeDistrict &&
												user?.nativeState &&
												user?.nativePlacePincode && (
													<>
														<span>
															{' '}
															{user?.nativeBlock}, {user?.nativeDistrict} ,{user?.nativeState}{' '}
															{user?.nativePlacePincode}
														</span>
													</>
												)}
											<br />
										</td>
										<td>
											{user?.presentAddress && user?.presentnativeArea && (
												<>
													{user?.presentAddress}, {user?.presentnativeArea}
												</>
											)}
											<br />
											{user?.presentBlock &&
												user?.presentDistrict &&
												user?.presentState &&
												user?.presentPincode && (
													<>
														<span>
															{user?.presentBlock}, {user?.presentDistrict} ,{user?.presentState}{' '}
															{user?.presentPincode}
														</span>
													</>
												)}
										</td>

										{sansthaDetails?._id && (
											<>
												<td>
													{matchedMembership?.membershipStartDate
														? new Date(matchedMembership.membershipStartDate).toLocaleDateString(
																'en-US',
																{
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																},
														  )
														: '-'}
												</td>

												<td>
													{matchedMembership?.membershipEndDate
														? new Date(matchedMembership.membershipEndDate).toLocaleDateString(
																'en-US',
																{
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																},
														  )
														: '-'}
												</td>

												<td>{matchedMembership?.membershipType || '-'}</td>
											</>
										)}
										<td>
											{new Date(user?.joinedHubDate).toLocaleDateString('en-US', {
												year: 'numeric',
												month: 'short',
												day: 'numeric',
											})}
										</td>
										<td>
											{user?.premium === true ? (
												<span className="badge badge-primary">Premium Membership</span>
											) : (
												'-'
											)}
										</td>
										{sansthaDetails?._id && (
											<td>
												{matchedMembership?.status ? (
													<span
														className={`badge ${getStatusBadgeClass(matchedMembership.status)}`}
													>
														{matchedMembership.status} Membership
													</span>
												) : (
													'-'
												)}
											</td>
										)}

										{/* <td>
											<button
												onClick={e => {
													e.preventDefault()
													e.stopPropagation()
													navigate(`/user/details/${user?._id}`)
												}}
												className="btn btn-sm btn-primary mr-2"
												title="Details"
											>
												<em className="fa fa-eye fa-fw"></em>
											</button>
										</td> */}

										<td onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
											<button
												className="btn btn-link"
												onClick={e => {
													e.stopPropagation()
													setOpenMenuId(openMenuId === user._id ? null : user._id)
												}}
											>
												<em className="fa fa-ellipsis-v fa-lg"></em>
											</button>

											{openMenuId === user?._id && (
												<div
													className="dropdown-menu show"
													style={{
														position: 'absolute',
														right: 0,
														top: 80,
														zIndex: 1000,
														display: 'block',
														left: -120,
													}}
												>
													<button
														className="dropdown-item"
														onClick={() => {
															setOpenMenuId(null)
															navigate(`/user/details/${user._id}`)
														}}
													>
														<em className="fa fa-eye mr-2"></em>
														Details
													</button>

													{/* <button
														className="dropdown-item text-danger"
														onClick={() => {
															setOpenMenuId(null)
															handleBlockUser(user._id, user.isUserBlocked)
														}}
													>
														<em
															className={`fa ${user.isUserBlocked ? 'fa-unlock' : 'fa-lock'} mr-2`}
														></em>
														{user.isUserBlocked ? 'Unblock User' : 'Block User'}
													</button> */}
												</div>
											)}
										</td>
									</tr>
								)
							})
						) : (
							<tr>
								<td colSpan="6" className="text-center">
									No {userLabel}s data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{userspaginate && <Paginate paginate={userspaginate} page={userpage} setPage={setUserPage} />}
		</div>
	)
}
export default Users
